// IgnoreModal.js
import React from 'react';
import { Modal, Box, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ConformationModal = ({open,
    onClose,
    onSubmitModal,
    title ,
    message,
  })=>{

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      bgcolor: 'background.paper',
      border: '2px solid #ffff',
      boxShadow: 24,
      // padding: '25px 30px 30px !important',
      borderRadius: "10px",
      };
    
      const buttonStyle = {
        fontSize: '0.875rem',
        padding: '6px 12px',
      };

      return(
        <>
        <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
    <Box sx={style}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px',
    borderBottom: '1px solid #cfcfcf' }}>
        <h6 style={{ textAlign: 'left', margin: 0 }}>{title}</h6>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </div>
      {/* <hr /> */}
      <form className="" style={{padding: '20px 21px'}}>
        <p>{message}</p>
        <div className="text-end mt-4">
          <Button
            variant="contained"
            color="primary"
            type="submit"
            size="large"
            className="me-4 btn-sty"
            sx={{ mr: 2, ...buttonStyle }}
            onClick={onSubmitModal}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            color="error"
            size="large"
            className="btn-sty"
            sx={buttonStyle}
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </form>
    </Box>
  </Modal>
        
        </>
      )


}
export default ConformationModal;